import { trackEvent } from '@opendoor/shared-fe/analytics';
import { EventTrackingAction } from '@opendoor/shared-fe/declarations/EventTracking';

const CATEGORY = 'partnership-dashboard';

/**
 * @deprecated Use a typed Journey event for durable product behavior or an internal event for
 * engineering diagnostics.
 */
// oxlint-disable-next-line typescript/no-deprecated -- OFFER-4581: existing legacy analytics usage is tracked for removal
export default (action: EventTrackingAction, label: string, extra: any = {}) =>
  // oxlint-disable-next-line typescript/no-deprecated -- OFFER-4581: existing legacy analytics usage is tracked for removal
  trackEvent.apply(null, [CATEGORY, action, label, extra]);
